import { ModalManager } from '@Components/modal/ModalManager';
import { ModalProvider } from '@Hooks/modalManager/ModalProvider';
import { LayoutSwitcher } from '@Layout/LayoutSwitcher';
import { ErrorBoundary } from '@Services/observability/ErrorBoundary';
import { RouterDevTools } from '@Components/infra/devTools.tsx';

export const RootComponent = () => {
  return (
    <>
      <ErrorBoundary>
        <ModalProvider>
          <ModalManager />
          <LayoutSwitcher />
          <RouterDevTools />
        </ModalProvider>
      </ErrorBoundary>
    </>
  );
};
